var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 167,
    viewBox: "0 0 172 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.8922,
    cy: 82.2802,
    rx: 84.8922,
    ry: 82.2802,
    transform: "matrix(-1 0 0 1 171.108 1.23708)",
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/Layer_2.f72c895f582b04bef7e60698c29e0384.svg";
export { ForwardRef as ReactComponent };